import React from "react";
import { ScreenInterface, ApiHelper, NavigationHelper } from "../../helpers";
import { Row, Col, FormControl, FormGroup, FormLabel } from "react-bootstrap"
import { InputBox, ErrorMessages, SavedMessage } from "../../components"

interface Props {
  screen: ScreenInterface,
}

export const PairScreen: React.FC<Props> = props => {

  const [code, setCode] = React.useState("");
  const [errors, setErrors] = React.useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [savedKey, setSavedKey] = React.useState("");


  const handleChange = (e: any) => {
    setCode(e.currentTarget.value)
  }

  const validate = () => {
    let errors: string[] = [];
    if (code.length !== 4) errors.push("Code should be 4 digits long");
    setErrors(errors);
    return errors.length === 0;
  }

  const handleSave = () => {
    if (validate()) {
      setIsSubmitting(true);
      ApiHelper.post("/devices/pair", { pairingCode: code, screenId: props.screen.id }).then((data: any) => {
        setIsSubmitting(false);
        if (data.success) {
          setErrors([]);
          setSavedKey(NavigationHelper.getRefreshKey());
        }
        else setErrors(["Invalid pairing code"]);
      });
    }
  }



  return (
    <>
      <InputBox headerIcon="fas fa-tv" headerText="Pair TV" saveFunction={handleSave} saveText="Pair TV" isSubmitting={isSubmitting}  >
        <SavedMessage refreshKey={savedKey} />
        <ErrorMessages errors={errors} />
        <Row>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel htmlFor="name">Enter code displayed on screen</FormLabel>
              <FormControl name="code" id="code" value={code} onChange={handleChange} />
            </FormGroup>
          </Col>
        </Row>
      </InputBox >
    </>
  );

}